export default __webpack_public_path__ + "static/media/warehouse.7b221170.svg";